import { render, staticRenderFns } from "./SkinIcon.vue?vue&type=template&id=99e83a22&scoped=true&"
import script from "./SkinIcon.vue?vue&type=script&lang=js&"
export * from "./SkinIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e83a22",
  null
  
)

export default component.exports